import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listCloudProjects, type CloudProjectSummary } from '../cloud/syncClient';

export type { CloudProjectSummary };

export const CLOUD_PROJECTS_QUERY_KEY = ['projects', 'cloud'];

async function fetchCloudProjects(): Promise<CloudProjectSummary[]> {
  try {
    const data = await listCloudProjects({ page: 1, pageSize: 100 });
    return data.items;
  } catch {
    return [];
  }
}

export function useCloudProjects(enabled: boolean) {
  return useQuery({
    queryKey: CLOUD_PROJECTS_QUERY_KEY,
    queryFn: fetchCloudProjects,
    enabled,
    retry: false,
  });
}

export function useInvalidateCloudProjects() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: CLOUD_PROJECTS_QUERY_KEY });
}
